export const pageBreadcrumbTitles = {
  '/about': 'About Us',
  '/products': 'Products',
  '/services': 'Services',
  '/leadership': 'Leadership',
  '/achievements': 'Achievements',
  '/contact': 'Contact Us',
}

export function getPageBreadcrumbTitle(pathname) {
  return pageBreadcrumbTitles[pathname] ?? null
}
